'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'binoculars';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1e5';
var svgPathData = ['M16 356.9L16 432c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-152 0-144 0-16c0-4.4-3.6-8-8-8l-8 0-80 0-5.6 0c-16.1 0-29.8 12-31.8 28l-5.7 45.9c-3.6 28.6-13.1 56.2-27.9 80.9c-16.3 27.2-25 58.4-25 90.1zM112 64l0 32 80 0 0-32c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm112 80l0 128 64 0 0-128-64 0zm80-24l0 16 0 144 0 152c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-75.1c0-31.7-8.6-62.9-25-90.1c-14.8-24.7-24.3-52.3-27.9-80.9L437.4 140c-2-16-15.6-28-31.8-28l-5.6 0-80 0-8 0c-4.4 0-8 3.6-8 8zm16-56l0 32 80 0 0-32c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z', 'M128 48c-8.8 0-16 7.2-16 16l0 32 80 0 0-32c0-8.8-7.2-16-16-16l-48 0zM96 97.1L96 64c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 33.4c9.3 3.3 16 12.2 16 22.6l0 8 64 0 0-8c0-10.4 6.7-19.3 16-22.6L304 64c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 33.1c19.5 4.3 34.7 20.4 37.3 40.9L459 184c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3l0 75.1c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-144-64 0 0 144c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-75.1c0-34.6 9.4-68.6 27.2-98.3C40.9 235.8 49.7 210.4 53 184L58.7 138c2.6-20.5 17.8-36.6 37.3-40.9zM106.4 112c-16.1 0-29.8 12-31.8 28l-5.7 45.9c-3.6 28.6-13.1 56.2-27.9 80.9c-16.3 27.2-25 58.4-25 90.1L16 432c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-152 0-144 0-16c0-4.4-3.6-8-8-8l-8 0-80 0-5.6 0zm299.3 0l-5.6 0-80 0-8 0c-4.4 0-8 3.6-8 8l0 16 0 144 0 152c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-75.1c0-31.7-8.6-62.9-25-90.1c-14.8-24.7-24.3-52.3-27.9-80.9L437.4 140c-2-16-15.6-28-31.8-28zM320 96l80 0 0-32c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 32zM224 272l64 0 0-128-64 0 0 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinoculars = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;